import React, {FC, useContext, useEffect, useState} from "react";

import { DocumentUnion } from "shared/types/types";
import { DocumentsContext } from "features/documents";
import PageHeader from "components/PageHeader";
import DocumentsOverview from "./DocumentsOverview";
import NotificationsList from "components/NotificationsList";
import PiecesIdentiteNewComponent from "components/PiecesIdentiteNewComponent/PiecesIdentiteNewComponent";


const ListIDs: FC = () => {
	const [selectedRows, setSelectedRows] = useState<DocumentUnion[]>([]);
	const { followed, lostDocuments, allDocuments, refreshDocuments } = useContext(
		DocumentsContext
	);

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (followed) {
			setIsLoading(false); // Dès que le doc est chargé, on désactive le loader
		}
		else {
			refreshDocuments();
		}
	}, [allDocuments]);

	// Initialisation avec la valeur du localStorage (par défaut: true si non défini)
	const [showOverview, setShowOverview] = useState<boolean>(() => {
		// TODO : A décomenter pour faire marcher Video Prsentation
		// const storedValue = localStorage.getItem("DocumentsOverview");
		// return storedValue !== null ? JSON.parse(storedValue) : true;
		return false;
	});


	const handleSelectionChange = (rows: DocumentUnion[]) => {
		setSelectedRows(rows);
	};


	return (
		<>
			<PageHeader showBackBtn={false} title={"ID Tracker"} notification={true} description={"Soyez alerté en cas de tentative"}>
			</PageHeader>
			{showOverview ?
				(
					<DocumentsOverview
						setShowOverview={setShowOverview}
						showOverview={showOverview}
					/>
				)
				:
				(
					<div className="content__body">
						<PiecesIdentiteNewComponent />
					</div>


				)
			}
		</>
	);
};


export default ListIDs;
